export class MicroInsightUtils {

    static getStreakInsight(streak) {
        if (!streak) return null;

        const { workoutsThisWeek, weeklyWorkoutGoal, currentWeekStreak, longestWeekStreak } = streak;

        if (currentWeekStreak > 0 && currentWeekStreak > longestWeekStreak) {
            return `New longest streak! ${currentWeekStreak} consecutive weeks.`;
        }

        if (workoutsThisWeek >= weeklyWorkoutGoal && weeklyWorkoutGoal > 0) {
            return "Weekly goal met! Keep the momentum going.";
        }

        const remaining = weeklyWorkoutGoal - workoutsThisWeek;
        if (remaining === 1) {
            return "1 workout away from your weekly goal!";
        }

        if (currentWeekStreak >= 3 && longestWeekStreak > currentWeekStreak) {
            return `${currentWeekStreak}-week streak — your longest was ${longestWeekStreak}.`;
        }

        return null;
    }

    static getGoalInsight(goals) {
        if (!goals || goals.length === 0) return null;

        const now = new Date();
        const sevenDaysFromNow = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
        const goalsWithDeadline = goals.filter(g => g.deadline && !g.dateCompleted);
        const urgentGoals = goalsWithDeadline.filter(g => new Date(g.deadline) <= sevenDaysFromNow);

        if (urgentGoals.length > 0) {
            const name = urgentGoals[0].exercise?.name;
            return name
                ? `${name} goal deadline is within a week!`
                : `${urgentGoals.length} goal${urgentGoals.length > 1 ? 's' : ''} due within a week!`;
        }

        if (goals.length >= 3) {
            return `${goals.length} active goals — stay focused!`;
        }

        return null;
    }
}
